import React from "react";
import { Box, Paper, Stack, Typography } from "@mui/material";

const DashboardSummaryStrip = ({ items = [] }) => (
  <Paper variant="outlined" sx={{ borderColor: "#dadce0", borderRadius: 2, overflow: "hidden" }}>
    <Stack direction={{ xs: "column", sm: "row" }} divider={<Box sx={{ borderLeft: { sm: "1px solid #edf0f3" }, borderTop: { xs: "1px solid #edf0f3", sm: 0 } }} />}>
      {items.map((item) => (
        <Box key={item.label} sx={{ flex: 1, minWidth: 0, p: 2 }}>
          <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 800, letterSpacing: 0.45, textTransform: "uppercase" }}>
            {item.label}
          </Typography>
          <Typography variant="h5" sx={{ fontWeight: 850, mt: 0.5 }}>
            {item.value}
          </Typography>
          {!!item.helper && (
            <Typography variant="body2" color="text.secondary" sx={{ mt: 0.25 }} noWrap>
              {item.helper}
            </Typography>
          )}
        </Box>
      ))}
    </Stack>
  </Paper>
);

export default DashboardSummaryStrip;
